import { render } from "./EditMeeting.vue?vue&type=template&id=2ff74fd5&scoped=true"
import script from "./EditMeeting.vue?vue&type=script&lang=js"
export * from "./EditMeeting.vue?vue&type=script&lang=js"

import "./EditMeeting.vue?vue&type=style&index=0&id=2ff74fd5&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff74fd5"]])

export default __exports__